export enum FeaturesGatedEnum {
  FEATURE_ESTIMAGE_PAY_ENABLED = 'FEATURE_ESTIMAGE_PAY_ENABLED'
}
